import { render, staticRenderFns } from "./BaseIntlPhoneNumber.vue?vue&type=template&id=6fd3826c"
import script from "./BaseIntlPhoneNumber.vue?vue&type=script&lang=js"
export * from "./BaseIntlPhoneNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports